import React from 'react'
import { FADigitalReportSubmenu } from './FADigitalReportSubmenu'
import { FADisposalReport } from './GeneratedReport/FADisposalReport'
import { FADisposalParamsForm } from './Parameters/FADisposalParamsForm'
import { FARegisteredParamsForm } from './Parameters/FARegisteredParamsForm'
import { FARegisteredReport } from './GeneratedReport/FARegisteredReport'
import { FAWriteOffParamsForm } from './Parameters/FAWriteOffParamsForm'
import { FAWriteOffReport } from './GeneratedReport/FAWriteOffReport'
import { FADepreciationParamsForm } from './Parameters/FADepreciationParamsForm'
import { FADepreciationReport } from './GeneratedReport/FADepreciationReport'
import { FALedgerReportByTransactionDate } from './GeneratedReport/FALedgerReportByTransactionDate'
import { FALedgerReportByTransactionDateParamsForm } from './Parameters/FALedgerReportByTransactionDateParamsForm'
import { FATransferParamsForm } from './Parameters/FATransferParamsForm'
import { FATransferReport } from './GeneratedReport/FATransferReport'
import { FASummaryParamsForm } from './Parameters/FASummaryParamsForm'
import { FASummaryReport } from './GeneratedReport/FASummaryReport'
import { FADetailParamsForm } from './Parameters/FADetailParamsForm'
import { FADetailReport } from './GeneratedReport/FADetailReport'

const FADigitalReportRoutes = [
  {
    props: {
      exact: true,
      path: '/digital-reports/fixed-assets',
    },
    component: <FADigitalReportSubmenu mode="fixed-assets" />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-disposal-report/parameters',
    },
    component: <FADisposalParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-disposal-report/generated',
    },
    component: <FADisposalReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-registered-report/parameters',
    },
    component: <FARegisteredParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-registered-report/generated',
    },
    component: <FARegisteredReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-write-off-report/parameters',
    },
    component: <FAWriteOffParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-write-off-report/generated',
    },
    component: <FAWriteOffReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-depreciation-report/parameters',
    },
    component: <FADepreciationParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-depreciation-report/generated',
    },
    component: <FADepreciationReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-transfer-report/parameters',
    },
    component: <FATransferParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-transfer-report/generated',
    },
    component: <FATransferReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fa-ledger-report-by-transaction-date/parameters',
    },
    component: <FALedgerReportByTransactionDateParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fa-ledger-report-by-transaction-date/generated',
    },
    component: <FALedgerReportByTransactionDate />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-summary-report/parameters',
    },
    component: <FASummaryParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-summary-report/generated',
    },
    component: <FASummaryReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-detail-report/parameters',
    },
    component: <FADetailParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/fixed-assets/fixed-assets-detail-report/generated',
    },
    component: <FADetailReport />,
  },
  // {
  //   props: {
  //     exact: true,
  //     path:
  //       '/digital-reports/account-payable/user-login-log-report/parameters',
  //   },
  //   component: (
  //     <UserLoginLogParamsForm
  //       submenu="account-payable"
  //       smTitle="Account Payable"
  //     />
  //   ),
  // },
  // {
  //   props: {
  //     exact: true,
  //     path:
  //       '/digital-reports/account-payable/user-login-log-report/generated',
  //   },
  //   component: (
  //     <UserLoginLogReport
  //       submenu="account-payable"
  //       smTitle="Account Payable"
  //     />
  //   ),
  // },
]

export default FADigitalReportRoutes
